import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function ProfileBanner({ activeLeague, setActiveLeague, activeSeason, setActiveSeason }) {
  const [leagues, setLeagues] = useState([]);
  // const navigate = useNavigate();

  useEffect(() => {
    // Fetch active leagues
    axios.get('/api/leagues/active-leagues/', {
      withCredentials: true,
    })
      .then(response => {
        setLeagues(response.data);
        // Set the first league as the default active league if none is selected
        if (!activeLeague && response.data.length > 0) {
          const defaultLeague = response.data[0];
          setActiveLeague(defaultLeague);
          if (defaultLeague.seasons && defaultLeague.seasons.length > 0) {
            setActiveSeason(defaultLeague.seasons[0]); // Set first season as default
          }
        }
      })
      .catch(error => {
        console.error('Error fetching leagues:', error);
      });
  }, [setActiveLeague, setActiveSeason, activeLeague]);

  const handleLeagueClick = (league) => {
    setActiveLeague(league);
    if (league.seasons && league.seasons.length > 0) {
      setActiveSeason(league.seasons[0]);
    } else {
      setActiveSeason(null);
    }
  };

  return (
    <>
      {/* Card START */}
      <div className="card p-0">
        <div
          className="rounded-top banner-img"
          style={{
            backgroundImage: `url(${activeSeason && activeSeason.banner
              ? activeSeason.banner
              : `${process.env.PUBLIC_URL}/images/kb_static/Kickball_League_Banner.png`
              })`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        ></div>

        {/* Card body START */}
        <div className="card-body py-0">
          <div className="d-sm-flex align-items-start text-center text-sm-start">
            <div>
              <div className="avatar avatar-xxl mt-n5 mb-3">
                <img
                  className="avatar-img rounded-circle border border-white border-3"
                  src={activeLeague && activeLeague.logo ? activeLeague.logo : `${process.env.PUBLIC_URL}/images/kb_static/KLOC_circle.svg`}
                  alt={activeLeague ? `${activeLeague.name} Logo` : 'Default avatar'}
                />
              </div>
            </div>
            <div className="ms-sm-4 mt-sm-3">
              {/* Display the active league's name */}
              <h1 className="mb-0 h5">
                {activeLeague ? activeLeague.name : 'Select a League'}{' '}
                <i className="bi bi-patch-check-fill text-success small"></i>
              </h1>
              <p>
                {activeSeason
                  ? `${activeSeason.name} (${activeSeason.start_date} - ${activeSeason.end_date})`
                  : ''}
              </p>
            </div>
          </div>
          <ul className="list-inline mb-0 text-center text-sm-start mt-3 mt-sm-0">
            <li className="list-inline-item">
              <i className="bi bi-geo-alt me-1"></i> Lemont, IL
            </li>
            <li className="list-inline-item">
              <i className="bi bi-calendar2-plus me-1"></i> Starting {activeSeason ? activeSeason.start_date : ''}
            </li>
          </ul>
        </div>
        {/* Card body END */}
        <div className="card-footer mt-3 pt-2 pb-0">
          <ul className="nav nav-bottom-line align-items-center justify-content-center justify-content-md-start mb-0 border-0">
            {leagues.map((league) => (
              <li key={league.id} className="nav-item">
                <button
                  className={`nav-link ${activeLeague && activeLeague.id === league.id ? 'active' : ''}`}
                  onClick={() => handleLeagueClick(league)}
                >
                  {league.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {/* Card END */}
    </>
  );
}

export default ProfileBanner;
